module.exports = __webpack_public_path__ + "img/banner.1bce49b1.png";